import { type EditionAwarenessContextType } from './edition-awareness-context';

export const isEligibleForFreeToStandardUpgrade = (context: EditionAwarenessContextType) => {
	// We're excluding the edu experiment cohort from seeing the refresh experiment
	return (
		context.edition === 'free' &&
		context.product === 'jira' &&
		context.siteType !== 'EDU' &&
		context.siteType !== 'ORG'
	);
};
